import { Record } from "immutable";

import createFromJS from "../../../createFromJS";

export const EraRecord = Record({
  name: null,
  shortName: null,
  isBackwards: false,
  hasLeapYears: true,
  leapOffset: 0,
  duration: Number.MAX_SAFE_INTEGER
});

createFromJS.registerCallback("EraRecord", createFromJS.createPrimitiveCallback(EraRecord));
